import { useState, useEffect } from "react";
import styles from "./VideoPopup.module.css";
import { FaPlus, FaTrash } from "react-icons/fa";

const VideoPopup = ({ onClose, onSubmit, initialVideos = [] }) => {
  const [video, setVideo] = useState("");
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    // Load old videos on open
    if (initialVideos.length) {
      setVideos(initialVideos);
    } else {
      setVideos([]);
    }
  }, [initialVideos]);

  const handleChange = (index, value) => {
    const updated = [...videos];
    updated[index] = value;
    setVideos(updated);
  };

  const addVideo = () => {
    setVideos([...videos, video]);
    setVideo("");
  };

  const removeVideo = (index) => {
    const updated = [...videos];
    updated.splice(index, 1);
    setVideos(updated);
  };

  const handleSubmit = () => {
    const cleaned = videos.filter((v) => v.trim() !== "");
    onSubmit(cleaned);
    onClose();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <button className={styles.closeBtn} onClick={onClose}>
          &times;
        </button>

        <div className={styles.row}>
          <label className={styles.label}>Video Link</label>
          <input
            type="text"
            value={video}
            onChange={(e) => setVideo(e.target.value)}
            className={styles.input}
            placeholder="https://youtube.com/..."
          />
          {video && (
            <button className={styles.iconBtn} onClick={addVideo}>
              <FaPlus />
            </button>
          )}
        </div>

        {videos.map((link, index) => (
          <div key={index} className={styles.row}>
            <label className={styles.label}>Video {index + 1}</label>
            <input
              type="text"
              value={link}
              onChange={(e) => handleChange(index, e.target.value)}
              className={styles.input}
              disabled={true}
              placeholder="https://youtube.com/..."
            />
            <button
              className={styles.iconBtn}
              onClick={() => removeVideo(index)}
            >
              <FaTrash />
            </button>
          </div>
        ))}

        <button className={styles.submitBtn} onClick={handleSubmit}>
          ▶ SUBMIT VIDEOS
        </button>
      </div>
    </div>
  );
};

export default VideoPopup;
